<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="confirmPasswordForm">
    <ion-label class="title">{{ 'ACCOUNT.email.password.title' | translate }}</ion-label>
    <ion-label *ngIf="location === 'email'">{{ 'ACCOUNT.email.password.p' | translate }}</ion-label>
    <ion-label *ngIf="location === 'phone'">{{ 'ACCOUNT.phoneNumber.password.p' | translate }}</ion-label>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        #passwordAccount
        label="{{ 'ACCOUNT.email.password.label' | translate }}"
        labelPlacement="stacked"
        [type]="passVisible ? 'text' : 'password'"
        (keyup.enter)="continue()"
        clear-on-edit="false"
        formControlName="password"
      ></ion-input>
      <ion-icon
        [name]="passVisible ? 'eye-off' : 'eye'"
        color="primary"
        slot="end"
        (click)="passVisible = !passVisible; passwordAccount.setFocus()"
      ></ion-icon>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="confirmPasswordForm.controls.password.hasError('required') && confirmPasswordForm.touched">
        {{ 'ACCOUNT.password.error.needCurrentPass' | translate }}
      </span>
    </div>
    <ion-button (click)="continue()" mode="ios">{{ 'SHARED.actions.continue' | translate }}</ion-button>
  </form>
</ion-content>
